<div class="panel">
  <div class="panel-header" (click)="toggle()">

    <div class="title">
      {{ header }}
    </div>

    <div class="icon">
      <span *ngIf="!isExpanded" mmIkonaSvg="strzalka_w_dol"
        matTooltip="{{'codes.strona-startowa.etykieta-rozwin' | translate}}"
      attr.aria-label="{{'codes.strona-startowa.etykieta-rozwin' | translate}}"></span>
      <span *ngIf="isExpanded" mmIkonaSvg="strzalka_w_gore"
        matTooltip="{{'codes.strona-startowa.etykieta-zwin' | translate}}"
      attr.aria-label="{{'codes.strona-startowa.etykieta-zwin' | translate}}"></span>
    </div>

  </div>

<div class="panel-content">

  <div class="text-wrapper"
       [class.collapsed]="!isExpanded" [mmFormatowanieInformacjiOObiekcie]="content" dozwoloneTagiHtml="a,b">
  </div>

</div>
</div>
